import { gql } from '@apollo/client'

export const CREATE_TASK_MUTATION = gql`
  mutation createTask($attributes: TaskInput!) {
    createTask(attributes: $attributes) {
      createdAt
      done
      dueDate
      id
      processingId
      title
      updatedAt
    }
  }
`
